import React from "react";

const Pagination = ({ pagination, onPageChange }) => {
  const { page, totalPages, hasNextPage, hasPrevPage } = pagination;

  const getPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 7;

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (page <= 4) {
        for (let i = 1; i <= 5; i++) pages.push(i);
        pages.push("...");
        pages.push(totalPages);
      } else if (page >= totalPages - 3) {
        pages.push(1);
        pages.push("...");
        for (let i = totalPages - 4; i <= totalPages; i++) pages.push(i);
      } else {
        pages.push(1);
        pages.push("...");
        for (let i = page - 1; i <= page + 1; i++) pages.push(i);
        pages.push("...");
        pages.push(totalPages);
      }
    }

    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="mt-8 flex items-center justify-center gap-2">
      <button
        onClick={() => onPageChange(page - 1)}
        disabled={!hasPrevPage}
        className={`px-4 py-2 rounded-md font-medium transition-colors ${
          hasPrevPage
            ? "bg-gray-700 text-white border border-gray-600 hover:bg-gray-600"
            : "bg-gray-800 text-gray-500 cursor-not-allowed"
        }`}
      >
        Previous
      </button>

      <div className="hidden sm:flex gap-2">
        {pageNumbers.map((pageNum, index) =>
          pageNum === "..." ? (
            <span key={`ellipsis-${index}`} className="px-4 py-2 text-gray-400">
              ...
            </span>
          ) : (
            <button
              key={pageNum}
              onClick={() => onPageChange(pageNum)}
              className={`px-4 py-2 rounded-md font-medium transition-colors ${
                pageNum === page
                  ? "bg-blue-600 text-white"
                  : "bg-gray-700 text-white border border-gray-600 hover:bg-gray-600"
              }`}
            >
              {pageNum}
            </button>
          )
        )}
      </div>

      <div className="sm:hidden px-4 py-2 bg-gray-700 border border-gray-600 rounded-md">
        <span className="text-sm text-white">
          Page {page} of {totalPages}
        </span>
      </div>

      <button
        onClick={() => onPageChange(page + 1)}
        disabled={!hasNextPage}
        className={`px-4 py-2 rounded-md font-medium transition-colors ${
          hasNextPage
            ? "bg-gray-700 text-white border border-gray-600 hover:bg-gray-600"
            : "bg-gray-800 text-gray-500 cursor-not-allowed"
        }`}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
